module.exports = __webpack_public_path__ + "static/media/LEO_TRADO.dc937ccc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/LEO_TRADO.svg
// module id = 349
// module chunks = 0